import { useState } from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Chip
} from '@mui/material';
import { ExpandMore, ErrorOutline, WarningAmber } from '@mui/icons-material';

export const ErrorDisplay = ({ errors }) => {
  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <Box
      sx={{
        bgcolor: 'error.50',
        border: '1px solid',
        borderColor: 'error.300',
        color: 'error.700',
        py: 3,
        px: 2,
        borderRadius: 2,
        maxHeight: 384,
        overflow: 'auto',
        width: '100%'
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <ErrorOutline sx={{ color: 'error.main' }} />
        <Typography variant="h6" fontWeight="bold">
          Errors
        </Typography>
        <Chip
          label={errors.length}
          size="small"
          sx={{
            bgcolor: 'error.main',
            color: 'white',
            fontSize: '0.75rem'
          }}
        />
      </Box>

      {errors.map((error) => (
        <Accordion
          key={error.row}
          expanded={expanded === error.row}
          onChange={handleChange(error.row)}
          sx={{
            mt: 1,
            '&:before': { display: 'none' },
            boxShadow: 'none',
            border: '1px solid',
            borderColor: 'error.200',
            borderRadius: 1,
            overflow: 'hidden'
          }}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            sx={{
              bgcolor: 'error.100',
              '&:hover': { bgcolor: 'error.200' },
              '&.Mui-expanded': { bgcolor: 'error.200' }
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <WarningAmber sx={{ color: 'error.main', fontSize: 20 }} />
              <Typography fontWeight="medium">Row {error.row}</Typography>
            </Box>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              bgcolor: 'white',
              borderLeft: '4px solid',
              borderColor: 'error.main',
              p: 3
            }}>
            <List dense sx={{ py: 0 }}>
              {error.errors.map((err, index) => (
                <ListItem key={index} sx={{ px: 0, py: 1 }}>
                  <ListItemText
                    primary={
                      <Box>
                        <Typography
                          variant="body2"
                          fontWeight="bold"
                          color="error.main"
                          sx={{ textTransform: 'capitalize', mb: 0.5 }}>
                          {err.column}:
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {err.message}
                        </Typography>
                        {err.value && (
                          <Chip
                            label={`Value: ${err.value}`}
                            size="small"
                            variant="outlined"
                            sx={{
                              mt: 1,
                              fontSize: '0.7rem',
                              height: 20
                            }}
                          />
                        )}
                      </Box>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default ErrorDisplay;
